import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import img from './catalogue.jpg';
import pptxgen from 'pptxgenjs';
import img1 from './erp.png';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import img2 from './powerpoint.png';
import img3 from './excel.png';
import img4 from './pdfFinal.png';
import VisibleIcon from '@rsuite/icons/Visible';
import EditIcon from '@rsuite/icons/Edit';
import globalIP from '../../GlobelIP';
import s1 from './templates/s1.jpg';
import s2 from './templates/s2.jpg';
import s3 from './templates/s3.png';
import s4 from './templates/s4.jpg';
import s5 from './templates/s5.jpg';
import m5 from './templates/m5.jpg';
import t1 from './templates/t1.jpg';
import f1 from './templates/f1.jpg';
import garment1 from './formatsPage/garment1.jpg';
import garment2 from './formatsPage/garment2.jpg';
import garment3 from './formatsPage/garment3.jpg';
import garment4 from './formatsPage/garment4.jpg';
import fontImages from './formatsPage/ikae 2.jpg';
import fontImages1 from './formatsPage/ikae3.jpg';
import fontImages2 from './formatsPage/ppt .jpg';
import {
  Button,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  ButtonGroup,
  Panel,
  Container,
  Modal,
  Placeholder,
  FlexboxGrid,
  Col,
  Input,
  Message,
  Drawer,
  InputGroup,
  InputNumber,
  useToaster,
  DateRangePicker,
  Checkbox
} from 'rsuite';
import { useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { Icon } from '@rsuite/icons';
import ImageIcon from '@rsuite/icons/Image';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { pdf, renderToString } from '@react-pdf/renderer';
import CopyToClipboard from 'react-copy-to-clipboard';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { log } from 'console';
import ugr from '@/UGRoute';

declare module 'jspdf' {
  interface jsPDF {
    autoTable: (options: object) => jsPDF;
  }
}

const GenerateColl = () => {
  const ip = globalIP;
  const [cata, setCata] = useState([]);
  const [cataName, setCataName] = useState('');
  const [colCode, setColCode] = useState('');
  const [cataloguedata1, setCataloguedata1] = useState([]);
  const [collectionbyid, setCollectionByid] = useState([]);
  // const [openGenerateSlider, setOpenGenerateSlider] = useState(false);
  // const [linkGenrate, setLinkGenrate] = useState()
  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const collectionName = queryParams.get('collectionname');
    const collectionCode = queryParams.get('collectioncode');
    // const encodedData = queryParams.get('data');
    // const catalogueName = queryParams.get('collectionname');
    // setCataName(catalogueName);
    setCataName(collectionName);
    setColCode(collectionCode);

    // if (encodedData == null) {
    // } else {

    //   const decodedData = decodeURIComponent(encodedData);
    //   const parsedData: any[] = JSON.parse(decodedData);
    //   setCata(parsedData);
    // }
  }, [location.search]);

  const [cataloguedata, setCatalogueData] = useState([]);
  const [buyername, setBuyerName] = useState('');
  useEffect(() => {
    if (colCode) {
      fetchDatacatadata();
    }
  }, [colCode]);
  const fetchDatacatadata = async () => {
    const response = await fetch(
      `${ip}/api/collections?populate=*&filters[CollectionCode][$eq]=${colCode}`
    );
    const json = await response.json();
    setCatalogueData(json.data);
    setCataloguedata1(json.data.flatMap(collection => collection.attributes.CollectionProduct));
    const collectProducts = json.data.flatMap(collection =>
      collection.attributes.CollectionProduct.map(product => product.ColProduct)
    );
    setCollectionByid(collectProducts);
    setBuyerName(json.data[0]?.attributes.BuyerName);
  };

  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('id') || '';
  const collname = searchParams.get('collectionname') || '';

  useEffect(() => {
    if (selectedItems) {
      fetchDatabyid();
      setCataName(collname);
    }
  }, [selectedItems]);
  const fetchDatabyid = async () => {
    const response = await fetch(
      `${ip}/api/collections?populate=*&filters[id][$eq]=${selectedItems}`
    );
    const json = await response.json();
    setCataloguedata1(json.data.flatMap(collection => collection.attributes.collectionProduct));
    const collectProducts = json.data.flatMap(collection =>
      collection.attributes.CollectionProduct.map(product => product.CollectProduct)
    );
    setCollectionByid(collectProducts);
    setBuyerName(json.data[0]?.attributes.BuyerName);
  };
  useEffect(() => {
    if (collectionbyid) {
      fetchProducts();
    }
  }, [collectionbyid]);
  const fetchProducts = async () => {
    try {
      // Create an array of query parameters for each matching ID
      const productIdsQueryParam = collectionbyid.map(id => `filters[id][$in][]=${id}`).join('&');
      const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*&pagination[page]=1`;
      const response = await fetch(apiUrl);
      const json = await response.json();
      const allData = [];
      if (productIdsQueryParam) {
        for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
          const pageResponse = await fetch(
            `${ip}/api/products?${productIdsQueryParam}&populate=*&pagination[page]=${page}`
          );
          const pageJson = await pageResponse.json();
          allData.push(...pageJson.data);
        }
      }

      const productvarid = collectionbyid.map(id => `filters[id][$eq]=${id}`).join('&');
      const responsevar = await fetch(`${ip}/api/variant-products?${productvarid}&populate=*`);
      const jsonvar = await responsevar.json();
      const catadata = [...allData, ...jsonvar.data];
      if (selectedItems || cataName) {
        // setCata(json.data)
        setCata(catadata);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const searchParamsQ = new URLSearchParams(location.search);
  const selectedItemsQ = searchParamsQ.get('idq') || '';
  const catlenameQ = searchParamsQ.get('Qname') || '';

  const [cataloguebyidQ, setCatalogueByidQ] = useState([]);
  useEffect(() => {
    if (selectedItemsQ) {
      fetchDatabyidQ();
      setCataName(catlenameQ);
    }
  }, [selectedItemsQ]);
  const fetchDatabyidQ = async () => {
    const response = await fetch(
      `${ip}/api/quotations?populate=*&filters[id][$eq]=${selectedItemsQ}`
    );
    const json = await response.json();
    const catalogProductsQ = json.data.flatMap(catalogue =>
      catalogue.attributes.QuotationProduct.map(product => product.QuotationProductcode)
    );
    setCatalogueByidQ(catalogProductsQ);
  };
  useEffect(() => {
    if (cataloguebyidQ) {
      fetchProductsQ();
    }
  }, [cataloguebyidQ]);
  const fetchProductsQ = async () => {
    try {
      const productIdsQueryParam = cataloguebyidQ
        .map(id => `filters[ProductId][$in][]=${id}`)
        .join('&');
      const apiUrl = `${ip}/api/products?${productIdsQueryParam}&populate=*`;
      const response = await fetch(apiUrl);
      const json = await response.json();
      // Set the fetched products
      if (selectedItemsQ) {
        setCata(json.data);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const csvData = cata.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ColorName,
      cbm,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });

  const downloadExcelData = async data => {
    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];
    const headerMapping = {
      ProductId: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
      NetWeight: 'Net. Wt.',
      CategoryName: 'Category',
      FinishName: 'Finish',
      SizeUnit: 'Unit',
      ProductName: 'Product Name'
      // Add more header mappings as needed
    };
    const companyName = data1[0]?.attributes?.cmpnm || 'Your Company Name';
    const logoUrl = data1[0]?.attributes?.Logo?.data?.attributes?.url || '';
    const imag = `${ip}${logoUrl}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: {
          argb: 'FFC00000' // Adjust tab color as needed
        }
      }
    });
    const companyNameRow = worksheet.addRow([]);
    // Center the text in the cell
    companyNameRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    // Increase font size and make it bold
    companyNameRow.getCell(1).font = { size: 16, bold: true };
    const conpmayRow = worksheet.getRow(1); // Assuming the header is in the first row
    conpmayRow.height = 20;
    worksheet.mergeCells('A1:L3');
    worksheet.getCell('E1').value = companyName;
    // Add header row

    if (imag) {
      const logoResponse = await fetch(imag);
      const logoImageBuffer = await logoResponse.arrayBuffer();
      const logoImageId = workbook.addImage({
        buffer: logoImageBuffer,
        extension: 'png' // Adjust the image format as needed
      });

      // Insert the logo in a cell to the left of the company name cell
      worksheet.addImage(logoImageId, { tl: { col: 1, row: 0.5 }, ext: { width: 90, height: 40 } });
    }
    const desiredColumnOrder = [
      'id',
      'Image',
      'ProductId',
      'Description',
      'ProductName',
      'SizeUnit',
      'Length',
      'Width',
      'Height',
      'NetWeight',
      'CategoryName',
      'FinishName'

      // ... (other columns)
    ];
    const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
    const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerchange);
    const headerRow = worksheet.getRow(4); // Assuming the header is in the first row
    headerRow.height = 30; // Adjust the height as needed
    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: index % 2 === 0 ? { argb: 'e5e5e5' } : { argb: 'e5e5e5' } // Alternate background colors
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });
    worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('D').width = 30; // Adjust the width as needed for column B
    worksheet.getColumn('E').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('C').width = 10; // Adjust the width as needed for column B
    worksheet.getColumn('K').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('L').width = 20; // Adjust the width as needed for column B

    // Fetch and embed images
    for (const item of data) {
      const imageUrl = item.Image;
      // Fetch the image data
      const response = await fetch(imageUrl);
      const imageBuffer = await response.arrayBuffer();
      // Embed the image in the worksheet
      const imageId = workbook.addImage({
        buffer: imageBuffer,
        extension: 'png' // Adjust the image format as needed
      });
      // Add a row with data
      const values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null));
      worksheet.addRow(values);
      // Set the image in a cell in a new row
      const rowNumber = worksheet.rowCount;
      worksheet.addImage(imageId, {
        tl: { col: 1.3, row: worksheet.rowCount - 0.2 }, // Adjust the column as needed
        ext: { width: 100, height: 100 } // Adjust the image size as needed
      });

      const row = worksheet.getRow(rowNumber);
      row.height = 100; // Adjust the height as needed

      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
      });
    }
    // Generate Excel buffer
    const excelBuffer = await workbook.xlsx.writeBuffer();
    // In a browser environment, you can use Blob and FileSaver to save the file
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    // Save the Excel file
    saveAs(excelData, `${cataName} Excel.xlsx`);
  };

  const downloadExcelData2 = async data => {
    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];
    const headerMapping = {
      ProductId: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
      NetWeight: 'Net. Wt.',
      CategoryName: 'Category',
      FinishName: 'Finish',
      ProductName: 'Product Name',
      SizeUnit: 'Unit'
      // Add more header mappings as needed
    };
    const companyName = data1[0]?.attributes?.cmpnm || 'Your Company Name';
    const logoUrl = data1[0]?.attributes?.Logo?.data?.attributes?.url || '';
    const imag = `${ip}${logoUrl}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: {
          argb: 'FFC00000' // Adjust tab color as needed
        }
      }
    });
    const companyNameRow = worksheet.addRow([]);
    // Center the text in the cell
    companyNameRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    // Increase font size and make it bold
    companyNameRow.getCell(1).font = { size: 16, bold: true };
    const conpmayRow = worksheet.getRow(1); // Assuming the header is in the first row
    conpmayRow.height = 20;
    worksheet.mergeCells('A1:L3');
    worksheet.getCell('E1').value = companyName;
    // Add header row

    if (imag) {
      const logoResponse = await fetch(imag);
      const logoImageBuffer = await logoResponse.arrayBuffer();
      const logoImageId = workbook.addImage({
        buffer: logoImageBuffer,
        extension: 'png' // Adjust the image format as needed
      });

      // Insert the logo in a cell to the left of the company name cell
      worksheet.addImage(logoImageId, { tl: { col: 1, row: 0.5 }, ext: { width: 80, height: 40 } });
    }

    const desiredColumnOrder = [
      'id',
      'Image',
      'ProductId',
      'Description',
      'ProductName',
      'SizeUnit',
      'Length',
      'Width',
      'Height',
      'NetWeight',
      'CategoryName',
      'FinishName'

      // ... (other columns)
    ];

    const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
    const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerchange);
    const headerRow = worksheet.getRow(4); // Assuming the header is in the first row
    headerRow.height = 30; // Adjust the height as needed
    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
        left: { style: 'medium', color: { argb: '00000000' } },
        bottom: { style: 'medium', color: { argb: '00000000' } },
        right: { style: 'medium', color: { argb: '00000000' } }
      };
    });
    worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('D').width = 30; // Adjust the width as needed for column B
    worksheet.getColumn('E').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('C').width = 10; // Adjust the width as needed for column B
    worksheet.getColumn('K').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('L').width = 20; // Adjust the width as needed for column B
    // Fetch and embed images
    for (const item of data) {
      const imageUrl = item.Image;
      // Fetch the image data
      const response = await fetch(imageUrl);
      const imageBuffer = await response.arrayBuffer();
      // Embed the image in the worksheet
      const imageId = workbook.addImage({
        buffer: imageBuffer,
        extension: 'png' // Adjust the image format as needed
      });
      // Add a row with data
      const values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null));
      worksheet.addRow(values);
      // Set the image in a cell in a new row
      worksheet.addImage(imageId, {
        tl: { col: 1.3, row: worksheet.rowCount - 0.5 }, // Adjust the column as needed
        ext: { width: 100, height: 100 } // Adjust the image size as needed
      });
      const rowNumber = worksheet.rowCount;
      const row = worksheet.getRow(rowNumber);
      row.height = 100; // Adjust the height as needed
      row.getCell(2).border = {
        top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
        left: { style: 'medium', color: { argb: '00000000' } },
        bottom: { style: 'medium', color: { argb: '00000000' } },
        right: { style: 'medium', color: { argb: '00000000' } }
      };
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
            left: { style: 'medium', color: { argb: '00000000' } },
            bottom: { style: 'medium', color: { argb: '00000000' } },
            right: { style: 'medium', color: { argb: '00000000' } }
          };
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
      });
    }
    // Generate Excel buffer
    const excelBuffer = await workbook.xlsx.writeBuffer();
    // In a browser environment, you can use Blob and FileSaver to save the file
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    // Save the Excel file
    saveAs(excelData, `${cataName} Excel.xlsx`);
  };

  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchData();
    fetchData1();
  }, []);
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };
  const [catappt, setCataPpt] = useState([]);
  const fetchData1 = async () => {
    const response = await fetch(`${ip}/api/temp-libs?populate=*&filters[Type][$eq]=Regular`);
    const json = await response.json();
    setCataPpt(json.data);
  };
  const handleDownloadPPT1 = async () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      // let logoImageUrl = garment1;
      const logoImageUrl = catappt[0]?.attributes?.CSPath?.data?.attributes?.url;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };

        slide.addImage({ path: img, ...logoOptions });
      }
    };
    addIntroductionSlide();
    const addProductSlide = async (product, serialNumber, collection) => {
      const slide = ppt.addSlide();
      // Define the background color for the slide
      const slideBackgroundColor = {
        x: 0.15,
        y: 0.1,
        w: '55%',
        h: '95.5%',
        fill: '#FFFFFF', // Set the background color here
        line: {
          color: '#000000',
          width: 0.5
        }
      };

      slide.addShape('rect', slideBackgroundColor);
      const slideBackgroundColorc = {
        x: 6,
        y: 0.1,
        w: '38%',
        h: '40%',
        fill: '#FFFFFF', // Set the background color here
        line: {
          color: '#000000',
          width: 0.5
        }
      };

      slide.addShape('rect', slideBackgroundColorc);
      async function getBase64ImageFromUrl(imageUrl) {
        const res = await fetch(imageUrl, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result); // reader.result is a base64 data URL
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      try {
        const base64Data = await getBase64ImageFromUrl(imageUrl);

        // Get dimensions (using the Image API)
        const img = new window.Image();
        img.src = base64Data;
        await new Promise((resolve) => (img.onload = resolve));

        const aspectRatio = img.naturalWidth / img.naturalHeight;

        // Define the max area you want the image to fit inside (in inches)
        const maxWidth = 4.5;   // the width of your left box
        const maxHeight = 5;    // the height limit you already use

        // Start with width-based scaling
        let w = maxWidth;
        let h = w / aspectRatio;

        // If that makes it too tall, rescale by height instead
        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Optionally center it within your box
        const boxX = 0.6;   // left edge of your image area
        const boxY = 0.25;  // top edge of your image area
        const boxW = maxWidth;
        const boxH = maxHeight;

        const x = boxX + (boxW - w) / 2;
        const y = boxY + (boxH - h) / 2;

        // Add the image
        slide.addImage({
          data: base64Data,
          x,
          y,
          w,
          h
        });

      } catch (err) {
        console.error('Image failed to load or convert:', err);
      }


      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 2; // Adjust the width of each image
        const imageHeight = 2; // Adjust the height of each image
        const xOffset = 6.9; // Adjust the x-offset of the images
        const yOffset = 0.2; // Adjust the initial y-offset of the images

        // Loop through the first two images or the available number of images
        const maxImages = Math.min(1, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: imageUrl, ...imageOptions });
        }
      }

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate valu

      if (productAlias) {
        const productidAttrCell = {
          text: `${label[0]?.attributes.AliasCode}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productcategory) {
        const categoryNameAttrCell = {
          text: `${label[0]?.attributes.Category}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productName) {
        const pnameAttrCell = {
          text: `${label[0]?.attributes.ProductName}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: `${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (producttype) {
        const producttypeAttrCell = {
          text: `${label[0]?.attributes.ProductType}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productdesc) {
        const discAttrCell = {
          text: `${label[0]?.attributes.Description}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'top'
          }
        };
        const discValCell = {
          text: `${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsize) {
        let sizeValue = '';
        if (
          'SizeUnit' in product.attributes &&
          'Length' in product.attributes &&
          'Width' in product.attributes &&
          'Height' in product.attributes
        ) {
          sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
        }
        // Add the combined size row if a valid sizeValue is available
        if (sizeValue) {
          const sizeAttrCell = {
            text: `${label[0]?.attributes.Sizeunit}`,
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${sizeValue}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productsizerange) {
        const sRangeAttrCell = {
          text: `${label[0]?.attributes.SizeRange}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const sRangeValCell = {
          text: `${product.attributes.SizeRange || 'N/A'}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          sRangeAttrCell,
          { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productfinish) {
        const finisheAttrCell = {
          text: `${label[0]?.attributes.finish}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: `${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productntw) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.NetWgt}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsalepri) {
        let price = '';
        if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
          price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
        }

        if (price) {
          const sizeAttrCell = {
            text: 'Price',
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${price}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productcbm) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.cbm}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.cbm?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 5.9,
        y: 2.4,
        w: '40%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: false // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    const reversedCata = [...cata].reverse();
    let serialCounter = 1;

    (async () => {
      for (const item of reversedCata) {
        await addProductSlide(item, serialCounter, cataloguedata1);
        serialCounter++;
      }

      // Download the PPT only after all slides are ready
      await ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
    })();


  };

  const handleDownloadPPT7 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlides = products => {
      const slide = ppt.addSlide();
      let xOffset = 0.7;

      for (const product of products) {
        const imageUrlc = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
        const maxWidth = 2.5;
        const maxHeight = 4;
        const aspectRatio = product.attributes.CoverImage?.data?.attributes?.width /
          product.attributes.CoverImage?.data?.attributes?.height || 1;

        let w = maxWidth;
        let h = w / aspectRatio;

        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Center inside box
        const x = xOffset - 0.4 + (maxWidth - w) / 2;
        const y = 0.2 + (maxHeight - h) / 2;
        slide.addImage({
          path: imageUrlc,
          x,
          y,
          w,
          h
        });

        // Create a table for the product attributes (similar to your previous code)
        const tableRows = [];
        let yOffset = 0.1;

        if ('ProductId' in product.attributes) {
          const productidAttrCell = {
            text: 'Alias Code',
            options: {
              fontSize: 10,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          const productidValCell = {
            text: `  ${product.attributes.ProductId?.toString() || ''}`,
            options: {
              fontSize: 8,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          tableRows.push([
            productidAttrCell,
            { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }

        const tableOptions = {
          x: xOffset,
          y: 4,
          w: 2,
          fontSize: 8,
          fontFace: 'Arial',
          autoPage: true
        };

        slide.addTable(tableRows, tableOptions);

        xOffset += 3; // Increment xOffset to position the next product
      }
    };

    let serialCounter = 0;
    while (serialCounter < cata.length) {
      const productsOnSlide = cata.slice(serialCounter, serialCounter + 3);
      addProductSlides(productsOnSlide);
      serialCounter += 3; // Move to the next set of three products
    }

    // Download the PPT file
    ppt.writeFile({ fileName: `${cataName} PPT.pptx` });
  };
  const handleDownloadPPT8 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlides = (products) => {
      const slide = ppt.addSlide();
      let xOffset = 0.9;

      for (const product of products) {
        const imageUrlc = `${ip}${product.attributes.CoverImage.data.attributes.url}`;

        // Assume you know the natural width/height of images, or use a fixed ratio (if all images are similar)
        // Example: max box size
        const maxWidth = 4;
        const maxHeight = 4;

        // If you can get image aspect ratio dynamically from your data:
        const aspectRatio = product.attributes.CoverImage?.data?.attributes?.width /
          product.attributes.CoverImage?.data?.attributes?.height || 1;

        let w = maxWidth;
        let h = w / aspectRatio;

        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Center inside box
        const x = xOffset - 0.4 + (maxWidth - w) / 2;
        const y = 0.2 + (maxHeight - h) / 2;

        slide.addShape('rect', {
          x: xOffset - 0.8,
          y: 0.1,
          w: 4.8,
          h: 4.2,
          fill: '#E5E4E2'
        });

        // Add image with adjusted w/h to maintain aspect ratio
        slide.addImage({
          path: imageUrlc,
          x,
          y,
          w,
          h
        });

        // Product table (unchanged)
        const tableRows = [];
        let yOffset = 0.1;

        if ('ProductId' in product.attributes) {
          tableRows.push([
            { text: 'Alias Code', options: { fontSize: 10, fontFace: 'Raleway', color: '#000000', border: { pt: 1, color: '#808080' }, bold: true, valign: 'middle' } },
            { text: `${product.attributes.ProductId?.toString() || ''}`, options: { fontSize: 8, fontFace: 'Raleway', color: '#000000', border: { pt: 1, color: '#808080' }, bold: true, valign: 'middle' } }
          ]);
          yOffset += 0.1;
        }

        if ('Description' in product.attributes) {
          tableRows.push([
            { text: 'Description', options: { fontSize: 10, fontFace: 'Raleway', color: '#000000', border: { pt: 1, color: '#808080' }, valign: 'top' } },
            { text: `${product.attributes.Description?.toString() || ''}`, options: { fontSize: 8, fontFace: 'Raleway', color: '#000000', border: { pt: 1, color: '#808080' }, valign: 'middle' } }
          ]);
          yOffset += 0.1;
        }

        const tableOptions = {
          x: xOffset - 0.8,
          y: 4.5,
          w: 4.8,
          fontSize: 8,
          fontFace: 'Arial',
          autoPage: false
        };

        slide.addTable(tableRows, tableOptions);

        xOffset += 5;
      }
    };


    let serialCounter = 0;
    while (serialCounter < cata.length) {
      const productsOnSlide = cata.slice(serialCounter, serialCounter + 2);
      addProductSlides(productsOnSlide);
      serialCounter += 2; // Move to the next set of three products
    }

    // Download the PPT file
    ppt.writeFile({ fileName: `${cataName} PPT.pptx` });
  };

  const handleDownloadPPT9 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlides = products => {
      const slide = ppt.addSlide();
      const productWidth = 2.5; // Width of each product
      const productHeight = 2; // Height of each product
      const xOffset = 2;
      const yOffset = 0.2;
      const xGap = 1; // Adjust the horizontal gap between products
      const yGap = 0.5;

      for (let i = 0; i < products.length; i++) {
        const product = products[i];

        const col = i % 2; // 0 or 1 for left or right columns
        const row = Math.floor(i / 2); // 0 or 1 for top or bottom rows

        const x = xOffset + col * (productWidth + xGap);
        const y = yOffset + row * (productHeight + yGap);

        const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;

        // Get aspect ratio from your image metadata if available
        const aspectRatio =
          product.attributes.CoverImage?.data?.attributes?.width /
          product.attributes.CoverImage?.data?.attributes?.height || 1;

        // Calculate width/height to fit inside box without stretching
        let w = productWidth;
        let h = w / aspectRatio;

        if (h > productHeight) {
          h = productHeight;
          w = h * aspectRatio;
        }

        // Center inside the grid box
        const adjustedX = x + (productWidth - w) / 2;
        const adjustedY = y + (productHeight - h) / 2;

        slide.addImage({
          path: imageUrl,
          x: adjustedX,
          y: adjustedY,
          w,
          h
        });


        // Create a table for the product attributes (similar to your previous code)
        const tableRows = [];

        if ('ProductId' in product.attributes) {
          const productidAttrCell = {
            text: 'Alias Code',
            options: {
              fontSize: 10,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          const productidValCell = {
            text: `:   ${product.attributes.ProductId?.toString() || ''}`,
            options: {
              fontSize: 8,
              fontFace: 'Raleway',
              color: '#000000',
              border: { pt: 1, color: '#808080' },
              valign: 'middle'
            }
          };
          tableRows.push([productidAttrCell, productidValCell]);
        }

        const tableOptions = {
          x: x,
          y: y + productHeight + 0.1, // Adjust vertical position for the table
          w: productWidth,
          fontSize: 8,
          fontFace: 'Arial',
          autoPage: true
        };

        slide.addTable(tableRows, tableOptions);
      }
    };

    let serialCounter = 0;
    while (serialCounter < cata.length) {
      const productsOnSlide = cata.slice(serialCounter, serialCounter + 4);
      addProductSlides(productsOnSlide);
      serialCounter += 4; // Move to the next set of three products
    }

    // Download the PPT file
    ppt.writeFile({ fileName: `${cataName} PPT.pptx` });
  };

  const handleDownloadPPT10 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const logoImageUrl = fontImages;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        const logoFullPath = fontImages;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 1.5, y: 4.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 4.5,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });

      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlide = (product, serialNumber) => {
      const slide = ppt.addSlide();
      // Define the background color for the slide
      const firstItem = data1.length > 0 ? data1[0] : null;
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 8.5, // Adjust the x-coordinate of the logo
          y: 0.3, // Adjust the y-coordinate of the logo
          w: 0.8, // Adjust the width of the logo
          h: 0.2 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      const imageOptions = {
        x: 0.6,
        y: 0.25,
        w: 4.5, // Adjust the width of the image as needed
        h: 5 // Adjust the height of the image as needed
      };
      slide.addImage({ path: imageUrl, ...imageOptions });

      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `:   ${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            bold: true,
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductName' in product.attributes) {
        const pnameAttrCell = {
          text: 'Product Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: `:   ${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('ProductTypeName' in product.attributes) {
        const producttypeAttrCell = {
          text: 'Product Type',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `:   ${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('Description' in product.attributes) {
        const discAttrCell = {
          text: 'Description',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const discValCell = {
          text: `:    ${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let sizeValue = '';
      if (
        'SizeUnit' in product.attributes &&
        'Length' in product.attributes &&
        'Width' in product.attributes &&
        'Height' in product.attributes
      ) {
        sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
      }

      // Add the combined size row if a valid sizeValue is available
      if (sizeValue) {
        const sizeAttrCell = {
          text: 'Product Size',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: `:    ${sizeValue}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if ('FinishName' in product.attributes) {
        const finisheAttrCell = {
          text: 'Finish Name',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: `:    ${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      let price = '';
      if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
        price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
      }
      if (price) {
        const sizeAttrCell = {
          text: 'Price',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const sizeValCell = {
          text: `:    ${price}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          sizeAttrCell,
          { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      if ('NetWeight' in product.attributes) {
        const ntAttrCell = {
          text: 'Net Weight',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `:    ${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 2, color: '#ffffff' },
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 6.7,
        y: 2.8,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    let serialCounter = 1;
    // Loop through each item in cata and add a slide for each product
    cata.forEach(item => {
      addProductSlide(item, serialCounter);
      serialCounter++;
    });

    // Download the PPT file
    ppt.writeFile({ fileName: 'Collection.pptx' });
  };

  const handleDownloadPPT2 = async () => {
    const ppt = new pptxgen();

    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = data1[0]?.attributes?.PPT_coverpage?.data?.attributes?.url;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        // const logoFullPath = fontImages;
        slide.addImage({ path: img, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      // slide.addText(
      //   [
      //     { text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } },
      //   ],
      //   { x: 1.5, y: 4.1, align: 'center' }
      // );
      // slide.addText(address, { x: 1.4, y: 4.5, fontSize: 14, fontFace: 'Raleway', color: '#303030', align: 'center' });

      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlide = async (product, serialNumber) => {
      const slide = ppt.addSlide();

      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      async function getBase64ImageFromUrl(imageUrl) {
        const res = await fetch(imageUrl, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result); // reader.result is a base64 data URL
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
      // Add the product image from the nested "CoverImage" attribute
      try {
        const base64Data = await getBase64ImageFromUrl(imageUrl);

        // Get dimensions (using the Image API)
        const img = new window.Image();
        img.src = base64Data;
        await new Promise((resolve) => (img.onload = resolve));

        const aspectRatio = img.naturalWidth / img.naturalHeight;

        // Define the max area you want the image to fit inside (in inches)
        const maxWidth = 4.5;   // the width of your left box
        const maxHeight = 5;    // the height limit you already use

        // Start with width-based scaling
        let w = maxWidth;
        let h = w / aspectRatio;

        // If that makes it too tall, rescale by height instead
        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Optionally center it within your box
        const boxX = 0.6;   // left edge of your image area
        const boxY = 0.25;  // top edge of your image area
        const boxW = maxWidth;
        const boxH = maxHeight;

        const x = boxX + (boxW - w) / 2;
        const y = boxY + (boxH - h) / 2;

        // Add the image
        slide.addImage({
          data: base64Data,
          x,
          y,
          w,
          h
        });

      } catch (err) {
        console.error('Image failed to load or convert:', err);
      }

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if (productAlias) {
        const productidAttrCell = {
          text: `${label[0]?.attributes.AliasCode}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productcategory) {
        const categoryNameAttrCell = {
          text: `${label[0]?.attributes.Category}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productName) {
        const pnameAttrCell = {
          text: `${label[0]?.attributes.ProductName}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: `${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (producttype) {
        const producttypeAttrCell = {
          text: `${label[0]?.attributes.ProductType}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productdesc) {
        const discAttrCell = {
          text: `${label[0]?.attributes.Description}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'top'
          }
        };
        const discValCell = {
          text: `${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsize) {
        let sizeValue = '';
        if (
          'SizeUnit' in product.attributes &&
          'Length' in product.attributes &&
          'Width' in product.attributes &&
          'Height' in product.attributes
        ) {
          sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
        }
        // Add the combined size row if a valid sizeValue is available
        if (sizeValue) {
          const sizeAttrCell = {
            text: `${label[0]?.attributes.Sizeunit}`,
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${sizeValue}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productsizerange) {
        const sRangeAttrCell = {
          text: `${label[0]?.attributes.SizeRange}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const sRangeValCell = {
          text: `${product.attributes.SizeRange || 'N/A'}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          sRangeAttrCell,
          { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productfinish) {
        const finisheAttrCell = {
          text: `${label[0]?.attributes.finish}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: `${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productntw) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.NetWgt}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsalepri) {
        let price = '';
        if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
          price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
        }

        if (price) {
          const sizeAttrCell = {
            text: 'Price',
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${price}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productcbm) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.cbm}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.cbm?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 6,
        y: 0.8,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: false // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 10,
              fontFace: 'Arial',
              color: '#000',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 9, y: 5.25 } // Adjust the position as needed
      );
      const lineOptionsnot = {
        x: 9, // X-coordinate of the line's starting point
        y: 0, // Y-coordinate of the line's starting point (just below the text)
        w: '5%', // Adjust the width of the line as needed
        h: 0.6, // Height of the line (adjust as needed)
        fill: '#d6d1cd' // Line color
      };
      slide.addShape('rect', lineOptionsnot);

      const lineOptionsnob = {
        x: 0.6, // X-coordinate of the line's starting point
        y: 5.03, // Y-coordinate of the line's starting point (just below the text)
        w: '5%', // Adjust the width of the line as needed
        h: 0.6, // Height of the line (adjust as needed)
        fill: '#d6d1cd' // Line color
      };
      slide.addShape('rect', lineOptionsnob);
    };
    const reversedCata = [...cata].reverse();
    let serialCounter = 1;

    (async () => {
      for (const item of reversedCata) {
        await addProductSlide(item, serialCounter);
        serialCounter++;
      }

      // Download the PPT only after all slides are ready
      await ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
    })();
  };

  const handleDownloadPPT3 = async () => {
    const ppt = new pptxgen();

    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = data1[0]?.attributes?.PPT_coverpage?.data?.attributes?.url;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 1.2, // Adjust the x-coordinate of the logo
          y: 0.6, // Adjust the y-coordinate of the logo
          w: 1, // Adjust the width of the logo
          h: 0.3 // Adjust the height of the logo
        };
        // const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: img, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
          }
        ],
        { x: 1.8, y: 2.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.6,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#303030',
        align: 'center'
      });
      slide.addText(email, {
        x: 0.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 2.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlide = async (product, serialNumber) => {
      const slide = ppt.addSlide();
      const headerBackground1 = {
        x: 0.3,
        y: 0.5,
        w: '10%', // Width spans the entire slide
        h: 0.3, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground = {
        x: 1.4,
        y: 0.5,
        w: '80%', // Width spans the entire slide
        h: 0.3, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground);

      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      async function getBase64ImageFromUrl(imageUrl) {
        const res = await fetch(imageUrl, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result); // reader.result is a base64 data URL
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
      // Add the product image from the nested "CoverImage" attribute
      try {
        const base64Data = await getBase64ImageFromUrl(imageUrl);
        // Get dimensions (using the Image API)
        const img = new window.Image();
        img.src = base64Data;
        await new Promise((resolve) => (img.onload = resolve));

        const aspectRatio = img.naturalWidth / img.naturalHeight;

        // Define the max area you want the image to fit inside (in inches)
        const maxWidth = 4.5;   // the width of your left box
        const maxHeight = 5;    // the height limit you already use

        // Start with width-based scaling
        let w = maxWidth;
        let h = w / aspectRatio;

        // If that makes it too tall, rescale by height instead
        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Optionally center it within your box
        const boxX = 0.6;   // left edge of your image area
        const boxY = 0.25;  // top edge of your image area
        const boxW = maxWidth;
        const boxH = maxHeight;

        const x = boxX + (boxW - w) / 2;
        const y = boxY + (boxH - h) / 2;
        console.log(x,
          y,
          w,
          h)

        // Add the image
        slide.addImage({
          data: base64Data,
          x,
          y,
          w,
          h
        });

      } catch (err) {
        console.error('Image failed to load or convert:', err);
      }

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if (productAlias) {
        const productidAttrCell = {
          text: `${label[0]?.attributes.AliasCode}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productcategory) {
        const categoryNameAttrCell = {
          text: `${label[0]?.attributes.Category}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productName) {
        const pnameAttrCell = {
          text: `${label[0]?.attributes.ProductName}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: `${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (producttype) {
        const producttypeAttrCell = {
          text: `${label[0]?.attributes.ProductType}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productdesc) {
        const discAttrCell = {
          text: `${label[0]?.attributes.Description}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'top'
          }
        };
        const discValCell = {
          text: `${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsize) {
        let sizeValue = '';
        if (
          'SizeUnit' in product.attributes &&
          'Length' in product.attributes &&
          'Width' in product.attributes &&
          'Height' in product.attributes
        ) {
          sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
        }
        // Add the combined size row if a valid sizeValue is available
        if (sizeValue) {
          const sizeAttrCell = {
            text: `${label[0]?.attributes.Sizeunit}`,
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${sizeValue}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productsizerange) {
        const sRangeAttrCell = {
          text: `${label[0]?.attributes.SizeRange}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const sRangeValCell = {
          text: `${product.attributes.SizeRange || 'N/A'}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          sRangeAttrCell,
          { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productfinish) {
        const finisheAttrCell = {
          text: `${label[0]?.attributes.finish}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: `${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productntw) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.NetWgt}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsalepri) {
        let price = '';
        if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
          price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
        }

        if (price) {
          const sizeAttrCell = {
            text: 'Price',
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${price}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productcbm) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.cbm}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.cbm?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 6,
        y: 1.3,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 10,
              fontFace: 'Arial',
              color: '#ffffff',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 0.5, y: 0.65 } // Adjust the position as needed
      );
    };
    const reversedCata = [...cata].reverse();
    let serialCounter = 1;

    (async () => {
      for (const item of reversedCata) {
        addProductSlide(item, serialCounter);
        serialCounter++;
      }

      // Download the PPT only after all slides are ready
      await ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
    })();
  };

  const handleDownloadPPT5 = async () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = fontImages2;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: '100%' // Adjust the height of the logo
        };
        const logoFullPath = fontImages2;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 0 - 1, y: 2.5, align: 'center' }
      );
      slide.addText(address, {
        x: 0 - 1,
        y: 3,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });

      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlide = async (product) => {
      const slide = ppt.addSlide();
      const backgroundColor = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height spans the entire slide
        fill: '#f4f6f5' // Replace 'yourColorCode' with your desired background color
      };
      slide.addShape('rect', backgroundColor);

      const squareColor = {
        x: 0, // X-coordinate for the square
        y: 0, // Y-coordinate for the square
        w: 0.5, // Width of the square
        h: 0.5, // Height of the square
        fill: '#ddd0bd' // Replace 'yourSquareColor' with your desired square color
      };
      slide.addShape('rect', squareColor);
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
          }
        ],
        { x: 1.4, y: 0.5, align: 'center' }
      );

      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 1, // Adjust the x-coordinate of the logo
          y: 0.4, // Adjust the y-coordinate of the logo
          w: 1, // Adjust the width of the logo
          h: 0.2 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      async function getBase64ImageFromUrl(imageUrl) {
        const res = await fetch(imageUrl, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result); // reader.result is a base64 data URL
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
      // Add the product image from the nested "CoverImage" attribute
      try {
        const base64Data = await getBase64ImageFromUrl(imageUrl);

        // Get dimensions (using the Image API)
        const img = new window.Image();
        img.src = base64Data;
        await new Promise((resolve) => (img.onload = resolve));

        const aspectRatio = img.naturalWidth / img.naturalHeight;

        // Define the max area you want the image to fit inside (in inches)
        const maxWidth = 4.5;   // the width of your left box
        const maxHeight = 5;    // the height limit you already use

        // Start with width-based scaling
        let w = maxWidth;
        let h = w / aspectRatio;

        // If that makes it too tall, rescale by height instead
        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Optionally center it within your box
        const boxX = 0.6;   // left edge of your image area
        const boxY = 0.25;  // top edge of your image area
        const boxW = maxWidth;
        const boxH = maxHeight;

        const x = boxX + (boxW - w) / 2;
        const y = boxY + (boxH - h) / 2;

        // Add the image
        slide.addImage({
          data: base64Data,
          x,
          y,
          w,
          h
        });

      } catch (err) {
        console.error('Image failed to load or convert:', err);
      }

      // Add the product attributes as a table

      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 1.8; // Adjust the width of each image
        const imageHeight = 1.8; // Adjust the height of each image
        const xOffset = 6; // Adjust the x-offset of the images
        const yOffset = 1.2; // Adjust the initial y-offset of the images

        // Loop through the first two images or the available number of images
        const maxImages = Math.min(2, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: imageUrl, ...imageOptions });
        }
      }

      const tableRows = [];

      if ('ProductId' in product.attributes) {
        const productIdAttrCell = {
          text: 'Alias Code',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#444343' }
        };
        const productIdValCell = {
          text: `: ${product.attributes.ProductId?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        const yOffset = 7; // Adjust the y-coordinate as needed
        const productIdOptions = { ...productIdValCell.options, y: yOffset };
        tableRows.push([productIdAttrCell, { ...productIdValCell, options: productIdOptions }]);
      }

      // ... (continue adding other attributes to the table)

      const tableOptions = {
        x: 0.5,
        y: 4.8,
        w: '20%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    // Loop through each item in cata and add a slide for each product
    const reversedCata = [...cata].reverse();
    let serialCounter = 1;

    (async () => {
      for (const item of reversedCata) {
        await addProductSlide(item);
        serialCounter++;
      }

      // Download the PPT only after all slides are ready
      await ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
    })();
  };

  const handleDownloadPPT6 = async () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = data1[0]?.attributes?.PPT_coverpage?.data?.attributes?.url;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: '100%' // Adjust the height of the logo
        };
        // const logoFullPath = fontImages2;
        slide.addImage({ path: img, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [{ text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } }],
        { x: 0 - 1, y: 2.5, align: 'center' }
      );
      slide.addText(address, {
        x: 0 - 1,
        y: 3,
        fontSize: 14,
        fontFace: 'Raleway',
        color: '#303030',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlide = async (product, serialNumber) => {
      const slide = ppt.addSlide();
      const backgroundColor = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height spans the entire slide
        fill: '#f4f6f5' // Replace 'yourColorCode' with your desired background color
      };
      slide.addShape('rect', backgroundColor);
      const squareColor = {
        x: 0, // X-coordinate for the square
        y: 0, // Y-coordinate for the square
        w: 0.5, // Width of the square
        h: 0.5, // Height of the square
        fill: '#ddd0bd' // Replace 'yourSquareColor' with your desired square color
      };
      slide.addShape('rect', squareColor);
      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      if (productAlias) {
        const productidAttrCell = {
          text: `${label[0]?.attributes.AliasCode}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        const productidValCell = {
          text: `${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            bold: true,
            valign: 'middle'
          }
        };
        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productcategory) {
        const categoryNameAttrCell = {
          text: `${label[0]?.attributes.Category}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const categoryNameValCell = {
          text: `${product.attributes.CategoryName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          categoryNameAttrCell,
          { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productName) {
        const pnameAttrCell = {
          text: `${label[0]?.attributes.ProductName}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const pnameValCell = {
          text: `${product.attributes.ProductName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          pnameAttrCell,
          { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (producttype) {
        const producttypeAttrCell = {
          text: `${label[0]?.attributes.ProductType}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const producttypeValCell = {
          text: `${product.attributes.ProductTypeName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          producttypeAttrCell,
          { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productdesc) {
        const discAttrCell = {
          text: `${label[0]?.attributes.Description}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'top'
          }
        };
        const discValCell = {
          text: `${product.attributes.Description?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          discAttrCell,
          { ...discValCell, options: { ...discValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsize) {
        let sizeValue = '';
        if (
          'SizeUnit' in product.attributes &&
          'Length' in product.attributes &&
          'Width' in product.attributes &&
          'Height' in product.attributes
        ) {
          sizeValue = `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`;
        }
        // Add the combined size row if a valid sizeValue is available
        if (sizeValue) {
          const sizeAttrCell = {
            text: `${label[0]?.attributes.Sizeunit}`,
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${sizeValue}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productsizerange) {
        const sRangeAttrCell = {
          text: `${label[0]?.attributes.SizeRange}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const sRangeValCell = {
          text: `${product.attributes.SizeRange || 'N/A'}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          sRangeAttrCell,
          { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productfinish) {
        const finisheAttrCell = {
          text: `${label[0]?.attributes.finish}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const finidhValCell = {
          text: `${product.attributes.FinishName?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          finisheAttrCell,
          { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productntw) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.NetWgt}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.NetWeight?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }
      if (productsalepri) {
        let price = '';
        if ('SellingPriceCurrency' in product.attributes && 'SellingPrice' in product.attributes) {
          price = `${product.attributes.SellingPriceCurrency} ${product.attributes.SellingPrice}`;
        }

        if (price) {
          const sizeAttrCell = {
            text: 'Price',
            options: {
              fontSize: 10,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          const sizeValCell = {
            text: `${price}`,
            options: {
              fontSize: 8,
              fontFace: 'raleway',
              color: '#000000',
              valign: 'middle'
            }
          };
          tableRows.push([
            sizeAttrCell,
            { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
          ]);
          yOffset += 0.1;
        }
      }
      if (productcbm) {
        const ntAttrCell = {
          text: `${label[0]?.attributes.cbm}`,
          options: {
            fontSize: 10,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        const ntValCell = {
          text: `${product.attributes.cbm?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'raleway',
            color: '#000000',
            valign: 'middle'
          }
        };
        tableRows.push([
          ntAttrCell,
          { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: 0.8,
        y: 1,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      async function getBase64ImageFromUrl(imageUrl) {
        const res = await fetch(imageUrl, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result); // reader.result is a base64 data URL
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
      // Add the product image from the nested "CoverImage" attribute
      try {
        const base64Data = await getBase64ImageFromUrl(imageUrl);

        // Get dimensions (using the Image API)
        const img = new window.Image();
        img.src = base64Data;
        await new Promise((resolve) => (img.onload = resolve));

        const aspectRatio = img.naturalWidth / img.naturalHeight;

        // Define the max area you want the image to fit inside (in inches)
        const maxWidth = 4.5;   // the width of your left box
        const maxHeight = 5;    // the height limit you already use

        // Start with width-based scaling
        let w = maxWidth;
        let h = w / aspectRatio;

        // If that makes it too tall, rescale by height instead
        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Optionally center it within your box
        const boxX = 0.6;   // left edge of your image area
        const boxY = 0.25;  // top edge of your image area
        const boxW = maxWidth;
        const boxH = maxHeight;

        const x = boxX + (boxW - w) / 2;
        const y = boxY + (boxH - h) / 2;

        // Add the image
        slide.addImage({
          data: base64Data,
          x: 5.4,
          y,
          w,
          h
        });

      } catch (err) {
        console.error('Image failed to load or convert:', err);
      }
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 12,
              fontFace: 'Arial',
              color: '#000000',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 0.5, y: 5.3 } // Adjust the position as needed
      );
    };
    const reversedCata = [...cata].reverse();
    let serialCounter = 1;
    for (const item of reversedCata) {
      await addProductSlide(item, serialCounter);
      serialCounter++;
    }
    await ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

  };

  const handleDownloadPPT4 = () => {
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';

      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 3.2, // Adjust the x-coordinate of the logo
          y: 0.5, // Adjust the y-coordinate of the logo
          w: 4, // Adjust the width of the logo
          h: 1 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }

      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
          }
        ],
        { x: 1.4, y: 2, align: 'center' }
      );
      slide.addText(address, {
        x: 1.4,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(email, {
        x: 1.4,
        y: 2.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 1.4,
        y: 3.1,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#000000',
        align: 'center'
      });
      // Add more text or content as desired
    };
    addIntroductionSlide();
    const addProductSlide = async (product) => {
      const slide = ppt.addSlide();

      const firstItem = data1.length > 0 ? data1[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
          }
        ],
        { x: 1.4, y: 0.5, align: 'center' }
      );

      const logoImageUrl = firstItem?.attributes.Logo.data.attributes.url || '';
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 1, // Adjust the x-coordinate of the logo
          y: 0.4, // Adjust the y-coordinate of the logo
          w: 1, // Adjust the width of the logo
          h: 0.2 // Adjust the height of the logo
        };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Add the product image from the nested "CoverImage" attribute
      const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      async function getBase64ImageFromUrl(imageUrl) {
        const res = await fetch(imageUrl, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result); // reader.result is a base64 data URL
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
      // Add the product image from the nested "CoverImage" attribute
      try {
        const base64Data = await getBase64ImageFromUrl(imageUrl);

        // Get dimensions (using the Image API)
        const img = new window.Image();
        img.src = base64Data;
        await new Promise((resolve) => (img.onload = resolve));

        const aspectRatio = img.naturalWidth / img.naturalHeight;

        // Define the max area you want the image to fit inside (in inches)
        const maxWidth = 4.5;   // the width of your left box
        const maxHeight = 5;    // the height limit you already use

        // Start with width-based scaling
        let w = maxWidth;
        let h = w / aspectRatio;

        // If that makes it too tall, rescale by height instead
        if (h > maxHeight) {
          h = maxHeight;
          w = h * aspectRatio;
        }

        // Optionally center it within your box
        const boxX = 0.6;   // left edge of your image area
        const boxY = 0.25;  // top edge of your image area
        const boxW = maxWidth;
        const boxH = maxHeight;

        const x = boxX + (boxW - w) / 2;
        const y = boxY + (boxH - h) / 2;

        // Add the image
        slide.addImage({
          data: base64Data,
          x,
          y,
          w,
          h
        });

      } catch (err) {
        console.error('Image failed to load or convert:', err);
      }

      // Add the product attributes as a table

      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 1.8; // Adjust the width of each image
        const imageHeight = 1.8; // Adjust the height of each image
        const xOffset = 6; // Adjust the x-offset of the images
        const yOffset = 1.2; // Adjust the initial y-offset of the images

        // Loop through the first two images or the available number of images
        const maxImages = Math.min(2, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: imageUrl, ...imageOptions });
        }
      }

      const tableRows = [];

      if ('ProductId' in product.attributes) {
        const productIdAttrCell = {
          text: 'Alias Code',
          options: { fontSize: 8, fontFace: 'Arial Black', color: '#444343' }
        };
        const productIdValCell = {
          text: `: ${product.attributes.ProductId?.toString() || ''}`,
          options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
        };
        const yOffset = 7; // Adjust the y-coordinate as needed
        const productIdOptions = { ...productIdValCell.options, y: yOffset };
        tableRows.push([productIdAttrCell, { ...productIdValCell, options: productIdOptions }]);
      }

      // ... (continue adding other attributes to the table)

      const tableOptions = {
        x: 0.5,
        y: 4.8,
        w: '20%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };

    // Loop through each item in cata and add a slide for each product
    const reversedCata = [...cata].reverse();
    let serialCounter = 1;

    (async () => {
      for (const item of reversedCata) {
        await addProductSlide(item,);
        serialCounter++;
      }

      // Download the PPT only after all slides are ready
      await ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
    })();
  };

  const generatePDF = (data: any[]) => {
    const doc = new jsPDF('landscape');
    const startX = 10;
    const startY = 10;
    const cellWidth = 30;
    const cellHeight = 20;
    const headerCellHeight = 10;
    const tableLineWidth = 0.1;
    const headerCellBackgroundColor = '#fcff2b';
    const maxDescriptionLength = 20;

    // Company info
    const cmpnam = data1.map(item => item.attributes.cmpnm);
    const address = data1.map(item => item.attributes.address);
    const logoUrl = data1.length > 0 ? data1[0].attributes.Logo.data.attributes.url : '';
    const img = `${ip}${logoUrl}`;

    doc.addImage(img, 'JPEG', startX + 10, startY + 3, 20, 10);

    const boxWidth = 270;
    const boxHeight = 20;
    const boxX = startX;
    const boxY = startY;
    doc.setLineWidth(tableLineWidth);
    doc.rect(boxX, boxY, boxWidth, boxHeight);

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    const boxText = cmpnam.length > 0 ? cmpnam[0] : 'Company Name';
    const textX = boxX + (boxWidth - doc.getStringUnitWidth(boxText) * doc.internal.scaleFactor) / 2;
    doc.text(boxText, textX, boxY + boxHeight / 3);

    const addressText = address.length > 0 ? address[0] : 'Address';
    const addressX = boxX + (boxWidth - doc.getStringUnitWidth(addressText) * doc.internal.scaleFactor) / 2;
    doc.text(addressText, addressX, boxY + boxHeight / 2);

    const addNewPageIfNecessary = (currentY: number) => {
      if (currentY + cellHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        return 10;
      }
      return currentY;
    };

    // Header labels
    const attributeDisplayNames = {
      aliascd: 'Style No',
      CoverImage: 'Image',
      description: 'Description',
      productname: 'Product Name',
      prodtypecd: 'Product Type',
      Dimension: 'Dimension',
      finish: 'Finish/Color',
      saleprice: 'Sale Price',
      netwgt: 'Net Weight'
    };

    // Add header
    let currentX = startX;
    let currentY = boxY + boxHeight;

    Object.values(attributeDisplayNames).forEach(label => {
      doc.setLineWidth(tableLineWidth);
      doc.setFillColor(headerCellBackgroundColor);
      doc.rect(currentX, currentY, cellWidth, headerCellHeight, 'F');
      doc.setTextColor(0, 0, 0);
      doc.rect(currentX, currentY, cellWidth, headerCellHeight, 'S');
      doc.text(label, currentX + 2, currentY + 7);
      currentX += cellWidth;
    });

    doc.setFontSize(8);
    currentY += headerCellHeight;

    // Add data rows
    data.forEach(product => {
      currentY = addNewPageIfNecessary(currentY);
      currentX = startX;

      // 1️⃣ Compute max row height
      let rowHeight = cellHeight;
      const cellHeights: Record<string, number> = {};

      Object.keys(attributeDisplayNames).forEach(key => {
        console.log(product)
        let value: any;
        switch (key) {
          case 'aliascd':
            value = product.attributes.ProductCode ?? '';
            break;
          case 'description':
            value = product.attributes.Description ?? '';
            break;
          case 'productname':
            value = product.attributes.ProductName ?? '';
            break;
          case 'prodtypecd':
            value = product.attributes.ProductTypeName ?? '';
            break;
          case 'finish':
            const finish = product.attributes.FinishName ?? '';
            const color = product.attributes.ColorName ?? '';
            value = finish && color ? `${finish}/${color}` : finish || color || '';
            break;
          case 'saleprice':
            const currency = product.attributes.SellingPriceCurrency ?? '';
            const price = product.attributes.SellingPrice ?? '';

            // Show actual currency, not symbol
            let sign = currency ? currency + ' ' : '';

            value = `${price} ${sign} `;
            break;

          case 'netwgt':
            value = product.attributes.NetWeight ?? '';
            break;
          case 'Dimension':
            value = `${product.attributes.Length || 0}x${product.attributes.Width || 0}x${product.attributes.Height || 0} ${product.attributes.SizeUnit || 'cm'}`;
            break;
          case 'CoverImage':
            value = product.attributes.CoverImage;
            break;
          default:
            value = product.attributes[key] ?? '';
        }

        // Calculate height for description and image
        if (key === 'description') {
          const lines = doc.splitTextToSize(value?.toString() || '', cellWidth - 2);
          const dynamicHeight = lines.length * 4 + 2;
          cellHeights[key] = dynamicHeight;
          if (dynamicHeight > rowHeight) rowHeight = dynamicHeight;
        } else if (key === 'CoverImage' && value?.data?.attributes?.url) {
          cellHeights[key] = cellHeight + 5; // image might need extra space
          if (cellHeights[key] > rowHeight) rowHeight = cellHeights[key];
        } else {
          cellHeights[key] = cellHeight;
        }
      });

      // 2️⃣ Draw all cells with the max rowHeight
      Object.keys(attributeDisplayNames).forEach(key => {
        doc.setLineWidth(tableLineWidth);
        doc.rect(currentX, currentY, cellWidth, rowHeight, 'S');

        let value: any;
        switch (key) {
          case 'aliascd':
            value = product.attributes.ProductId ?? '';
            break;
          case 'description':
            value = product.attributes.Description ?? '';
            break;
          case 'productname':
            value = product.attributes.ProductName ?? '';
            break;
          case 'prodtypecd':
            value = product.attributes.ProductTypeName ?? '';
            break;
          case 'finish':
            const finish = product.attributes.FinishName ?? '';
            const color = product.attributes.ColorName ?? '';
            value = finish && color ? `${finish}/${color}` : finish || color || '';
            break;
          case 'saleprice':
            const currency = product.attributes.SellingPriceCurrency ?? '';
            const price = product.attributes.SellingPrice ?? '';

            // Show actual currency, not symbol
            let sign = currency ? currency + ' ' : '';

            value = `${price} ${sign} `;
            break;

          case 'netwgt':
            value = product.attributes.NetWeight ?? '';
            break;
          case 'Dimension':
            value = `${product.attributes.Length || 0}x${product.attributes.Width || 0}x${product.attributes.Height || 0} ${product.attributes.SizeUnit || 'cm'}`;
            break;
          case 'CoverImage':
            value = product.attributes.CoverImage;
            break;
          default:
            value = product.attributes[key] ?? '';
        }

        if (key === 'description') {
          const lines = doc.splitTextToSize(value?.toString() || '', cellWidth - 2);
          let textY = currentY + 6;
          lines.forEach(line => {
            doc.text(line, currentX + 1, textY, { maxWidth: cellWidth - 2 });
            textY += 4;
          });
        } else if (key === 'CoverImage' && value?.data?.attributes?.url) {
          const imgSrc = `${ip}${value.data.attributes.url}`;

          // 1️⃣ Get image original size
          // If you don’t have width/height from API, you may need to preload it
          const originalWidth = value.data.attributes.width || cellWidth - 8;
          const originalHeight = value.data.attributes.height || cellHeight;

          const aspectRatio = originalWidth / originalHeight;

          // 2️⃣ Fit image inside cell
          let drawWidth = cellWidth - 8;
          let drawHeight = drawWidth / aspectRatio;

          if (drawHeight > rowHeight - 4) {
            drawHeight = rowHeight - 4;
            drawWidth = drawHeight * aspectRatio;
          }

          // 3️⃣ Center image in cell
          const offsetX = currentX + (cellWidth - drawWidth) / 2;
          const offsetY = currentY + (rowHeight - drawHeight) / 2;

          doc.addImage(imgSrc, 'JPEG', offsetX, offsetY, drawWidth, drawHeight);
        }
        else {
          const text = value?.toString() || '';
          const textWidth = doc.getStringUnitWidth(text) * doc.internal.scaleFactor;
          const textX = currentX + (cellWidth - textWidth) / 2;
          doc.text(text, currentX + 1, currentY + 7, { maxWidth: cellWidth - 2 });
        }

        currentX += cellWidth;
      });

      // 3️⃣ Move to next row
      currentY += rowHeight;
    });


    return doc;
  };


  const handleDownloadPDF = async () => {
    try {
      const doc = generatePDF(cata, cataloguedata1);

      // Save the PDF
      doc.save(`${cataName} PDF.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const generatePDF2 = (data, cataloguedata1) => {
    const doc = new jsPDF('portrait');
    const logoUrl = data1.length > 0 ? data1[0].attributes.Logo.data.attributes.url : '';
    const img = `${ip}${logoUrl}`;

    // Define the box properties for the logo
    const logoWidth = 25; // Adjust the logo width as needed
    const logoHeight = 10; // Adjust the logo height as needed
    const logoX = 100; // Adjust the X position as needed
    const logoY = 2.5; // Adjust the Y position as needed

    // Add the logo to the PDF
    doc.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

    // Define table properties
    const startX = 10;
    const startY = 20;
    const cellWidth = 100;
    const cellHeight = 10; // Decreased table cell height
    const fontSize = 10; // Decreased font size
    const tableLineWidth = 0.1;

    const attributeDisplayNames = {
      ProductId: 'Alias Code',
      Description: 'Description',
      ProductName: 'Product Name',
      ProductTypeName: 'Product Type',
      Dimension: 'Dimension',
      FinishName: 'Finish/Color',
      ProductCost: 'Price',
      NetWeight: 'Net. Wt.'
    };

    // Set the font style for the header cells

    // Function to add a new page when necessary
    const addNewPageIfNecessary = currentY => {
      if (currentY + cellHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        return 10; // Start from the top of the new page
      }
      return currentY;
    };

    // Function to display product data
    const displayProduct = (product, currentX, currentY) => {
      // Large image on the left side
      const value = product.attributes.CoverImage;
      const imageX = currentX + 4;
      const imageY = currentY;
      const imageWidth = cellWidth - 8;
      const imageHeight = 80; // Adjust image height as needed
      doc.setDrawColor(0); // Set border color
      doc.setLineWidth(1); // Set border width
      doc.rect(imageX, imageY, imageWidth, imageHeight);
      if (value) {
        const imageSrc = `${ip}${value.data.attributes.url}`;
        doc.addImage(imageSrc, 'JPEG', imageX, imageY, imageWidth, imageHeight);
      }

      // Right side with attribute names and values
      currentX += 100; // Adjust horizontal position
      doc.setFontSize(fontSize); // Set the font size

      Object.keys(attributeDisplayNames).forEach(key => {
        const attributeLabel = attributeDisplayNames[key];
        const attributeValue = product.attributes[key] || '';

        // Draw border for each cell
        doc.setLineWidth(tableLineWidth);
        doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');

        // Draw lines between attribute and value
        const lineX = currentX + cellWidth / 3.1;
        const lineY1 = currentY;
        const lineY2 = currentY + cellHeight;
        doc.line(lineX, lineY1, lineX, lineY2);

        // Display attribute label and value
        doc.text(attributeLabel, currentX + 2, currentY + 7);

        if (key === 'Description') {
          const descriptionLines = doc.splitTextToSize(attributeValue.toString(), 95 - 39);
          const displayedDescription = descriptionLines.slice(0, 2).join('\n');

          doc.text(displayedDescription, currentX + 33, currentY + 4);
          // Display the description text in multiple lines within the cell

          if (descriptionLines.length > 2) {
            // If there are more than 2 lines, add an indicator
            doc.text('.', currentX + 33, currentY + 4 + 7); // Adjust vertical position as needed
          }
        } else if (key === 'ProductName') {
          const descriptionLines = doc.splitTextToSize(attributeValue.toString(), 95 - 39);
          const displayedDescription = descriptionLines.slice(0, 2).join('\n');

          doc.text(displayedDescription, currentX + 33, currentY + 4);
          // Display the description text in multiple lines within the cell

          if (descriptionLines.length > 2) {
            // If there are more than 2 lines, add an indicator
            doc.text('.', currentX + 33, currentY + 4 + 7); // Adjust vertical position as needed
          }
        } else if (key === 'Dimension') {
          // Handle Dimension cell
          const dimensionString = `${product?.attributes?.Length || '0'} x ${product?.attributes?.Width || '0'
            } x ${product?.attributes?.Height || '0'} ${product?.attributes?.SizeUnit || 'unit'}`;
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(dimensionString, currentX + 34, currentY + 7);
        } else if (key === 'FinishName') {
          // Handle FinishName cell
          const dimensionString = `${product?.attributes?.FinishName || 'Finish'} / ${product?.attributes?.ColorName || 'Color'
            }`;
          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(dimensionString, currentX + 34, currentY + 7);
        } else if (key === 'ProductCost') {
          // Handle ProductCost cell (currency + value)
          const currency = product?.attributes?.SellingPriceCurrency || "";
          const price = product?.attributes?.SellingPrice || "";
          const costString = `${price} ${currency} `;

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(costString, currentX + 34, currentY + 7);
        }
        else {
          doc.text(attributeValue.toString(), currentX + cellWidth / 3, currentY + 7);
        }

        currentY += cellHeight; // Adjust vertical position
      });

      // Add a gap between products
      return currentY + 10; // Adjust the gap as needed
    };

    // Add data in a top-to-down format
    let currentX = startX;
    let currentY = startY;

    data.forEach(product => {
      currentY = addNewPageIfNecessary(currentY);
      currentY = displayProduct(product, currentX, currentY);
    });

    return doc;
  };

  const handleDownloadPDF2 = async () => {
    try {
      const doc = generatePDF2(cata, cataloguedata1);

      // Save the PDF
      doc.save(`${cataName} PDF.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const [value, setValue] = useState(1);
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const handleOpen = value => {
    setSize(value);
    setOpen(true);
  };
  function handleCountChange() {
    if (value === 1) {
      setValue(2);
    } else if (value === 2) {
      setValue(3);
    } else if (value === 3) {
      setValue(4);
    } else {
      setValue(1);
    }
  }
  const handleClose = () => setOpen(false);
  const [valuep, setValuep] = useState(1);
  const [openp, setOpenp] = useState(false);
  const [sizep, setSizep] = useState();
  const handleOpenp = value => {
    setSizep(value);
    setOpenp(true);
  };
  function handleCountChangep() {
    if (valuep === 1) {
      setValuep(2);
    } else if (valuep === 2) {
      setValuep(3);
    } else {
      setValuep(1);
    }
  }
  const handleClosep = () => setOpenp(false);

  ///////////////Excel Modal///////////////
  const [valuee, setValuee] = useState(1);
  const [showModalexcel, setShowModalexcel] = useState(false);
  const [selectedRowDataexcel, setSelectedRowDataexcel] = useState(null);
  const handleDownloadexcel = csvData => {
    setOpenexcel(true);
    setSelectedRowDataexcel(csvData);
    setShowModalexcel(true);
  };
  function handleCountChangee() {
    if (valuee === 1) {
      setValuee(2);
    } else if (valuee === 2) {
      setValuee(3);
    } else {
      setValuee(1);
    }
  }
  const [openexcel, setOpenexcel] = useState(false);
  const handleCloseexcel = () => setOpenexcel(false);

  //// copy link
  const [textToCopy, setTextToCopy] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = () => {
    setIsCopied(true);
    // You can add additional handling or feedback here.
  };
  //// copy link
  ///generate link
  const [link, setLink] = useState(false);
  const handlelinkOpen = () => setLink(true);
  const handlelinkClose = () => setLink(false);
  const [showCopyButton, setShowCopyButton] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]); // State to hold the selected date range

  // Function to handle changes in the selected date range
  const handleDateRangeChange = value => {
    setDateRange(value);
  };

  const [glogin, setGlogin] = useState({
    username: '',
    password: '',
    buyername: '',
    Timefrom: '',
    Timeto: '',
    merchant: '',
    Type: '',
    Status: '',
    buyercode: '',
    typecode: '',
    typename: ''
  });
  const handleInputChange = (inputName, event, index) => {
    let value;
    if (event && event.target) {
      // If event is not null and has a target property
      value = event.target.value;
    } else {
      // Handle cases where event is null or doesn't have a target property
      value = event;
    }
    setGlogin({ ...glogin, [inputName]: value });
  };
  const buyercode = cataloguedata.map(item => item.attributes.BuyerName);
  const catacode = cataloguedata.map(item => item.attributes.CollectionCode);
  const cataname = cataloguedata.map(item => item.attributes.CollectionName);

  function checkCataCode(cataCodes) {
    for (let i = 0; i < cataCodes.length; i++) {
      const cataCode = cataCodes[i];
      if (typeof cataCode.startsWith('COl')) {
        return `Collection`;
      }
    }
    return 'N/A';
  }

  const result = checkCataCode(catacode);
  const [clientdata, setClientData] = useState(0);
  const [clientdatacheck, setClientDataCheck] = useState([]);
  useEffect(() => {
    fetchDataClint();
  }, []);
  const fetchDataClint = async () => {
    const response = await fetch(`${ip}/api/client-logins?populate=*`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/client-logins?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setClientDataCheck(allData);
    setClientData(json.meta.pagination.total);
  };
  const toaster = useToaster();
  const generateClintCode = () => {
    const nextCode = clientdata + 1;
    return `CLI-${nextCode.toString().padStart(3, '0')}`;
  };
  let nextCategoryCode1 = generateClintCode();
  const logindetails = `${ip}/api/client-logins`;
  const handleOkClick = e => {
    e.preventDefault();
    if (glogin.username === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Username
        </Message>,
        { placement: 'topEnd' }
      );
    } else if (clientdatacheck.find(item => item.attributes.username === glogin.username)) {
      toaster.push(
        <Message showIcon type="error">
          Username Already Taken. Try Different
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      nextCategoryCode1 = generateClintCode();
      const nextCategoryCode = nextCategoryCode1;
      const generatedLink = `http://b2bportal:3100/apptwo?username=c54ta76logue5$5&password=p$fn5&#mgi%&`;
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...glogin,
          buyername: '',
          Timefrom: dateRange[0] ? dateRange[0].toISOString().slice(0, 10) : null,
          Timeto: dateRange[1] ? dateRange[1].toISOString().slice(0, 10) : null,
          merchant: '',
          Type: result,
          Status: 'Active',
          buyercode: String(buyercode),
          typecode: String(catacode),
          typename: String(cataname),
          client_id: nextCategoryCode
        })
      );
      fetch(logindetails, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // Refresh page after 2 seconds (2000 milliseconds)
        })
        .catch(error => {
          console.error(error);
        });
      setTextToCopy(generatedLink);
      setShowCopyButton(true);
      handlelinkClose();
    }
  };
  ///generate link

  const [openattri, setOpenAttri] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);
  const handleCloseandsave = () => {
    if (selectedButton === 'button1') {
      // Check which button was clicked
      handleDownloadPPT1();
    } else if (selectedButton === 'button2') {
      handleDownloadPPT2();
    } else if (selectedButton === 'button3') {
      handleDownloadPPT3();
    } else if (selectedButton === 'button4') {
      handleDownloadPPT6();
    }
    setOpenAttri(false);
    setSelectedButton(null);
  };

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);

  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [productAlias, setProductAlias] = useState(false);
  const [productName, setProductName] = useState(false);
  const [productsize, setProductSize] = useState(false);
  const [productsizerange, setProductsizerange] = useState(false);
  const [productfinish, setProductFinish] = useState(false);
  const [productntw, setProductNtw] = useState(false);
  const [productcbm, setProductCbm] = useState(false);

  const [productcategory, setProductCategory] = useState(false);
  const [producttype, setProductType] = useState(false);
  const [productdesc, setProductDesc] = useState(false);
  const [productcolor, setProductColor] = useState(false);
  const [productgrt, setProductGrt] = useState(false);
  const [productsalepri, setProductSalepri] = useState(false);
  const [productcurrency, setProductCurrency] = useState(false);
  const [productremark, setProductRemark] = useState(false);

  useEffect(() => {
    fetchDataHeads();
  }, []);
  const fetchDataHeads = async () => {
    const response = await fetch(`${ip}/api/product-attributes`);
    const json = await response.json();
    const aliascdExists = json.data.some(
      item => item.attributes.Heads === 'aliascd' && item.attributes.status === true
    );
    const nameExists = json.data.some(
      item => item.attributes.Heads === 'productname' && item.attributes.status === true
    );
    const sizeExists = json.data.some(
      item => item.attributes.Heads === 'size' && item.attributes.status === true
    );
    const finishExists = json.data.some(
      item => item.attributes.Heads === 'finish' && item.attributes.status === true
    );
    const colorExists = json.data.some(
      item => item.attributes.Heads === 'color' && item.attributes.status === true
    );
    const ntwExists = json.data.some(
      item => item.attributes.Heads === 'netwgt' && item.attributes.status === true
    );
    const cbmExists = json.data.some(
      item => item.attributes.Heads === 'cbm' && item.attributes.status === true
    );
    const ptypeExists = json.data.some(
      item => item.attributes.Heads === 'prodtypecd' && item.attributes.status === true
    );
    const descExists = json.data.some(
      item => item.attributes.Heads === 'description' && item.attributes.status === true
    );
    const cateExists = json.data.some(
      item => item.attributes.Heads === 'catcd' && item.attributes.status === true
    );
    const grtwExists = json.data.some(
      item => item.attributes.Heads === 'grswgt' && item.attributes.status === true
    );
    const saleExists = json.data.some(
      item => item.attributes.Heads === 'saleprice' && item.attributes.status === true
    );
    const srangeExists = json.data.some(
      item => item.attributes.Heads === 'sizerange' && item.attributes.status === true
    );

    setProductAlias(aliascdExists);
    setProductName(nameExists);
    setProductSize(sizeExists);
    setProductFinish(finishExists);
    setProductNtw(ntwExists);
    setProductCbm(cbmExists);
    setProductColor(colorExists);
    setProductType(ptypeExists);
    setProductDesc(descExists);
    setProductCategory(cateExists);
    setProductGrt(grtwExists);
    setProductSalepri(saleExists);
    setProductsizerange(srangeExists);
  };

  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  return (
    <>
      <Container className="main ">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <h3 className="title">Collection is here</h3>
            <Breadcrumb>
              <Breadcrumb.Item href={`/${ugr}/dashboard`}>Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Collection </Breadcrumb.Item>
            </Breadcrumb>
          </Stack>
          {isCopied ? <Message type="success">Copied!</Message> : null}
        </Stack>
        <Divider className="divide" />
        <Stack
          direction="column"
          alignItems="center"
          spacing={5}
          style={{ width: '100%' }}
          className="generate-cate"
        >
          <ButtonGroup
            style={{
              marginTop: 20,
              width: 700,
              gap: 20,
              marginBottom: 20,
              justifyContent: 'center',
              textAlign: 'center'
            }}
            justified
            className="generate-cate"
          >
            <Stack direction="column" spacing={10}>
              <img
                src={img2}
                style={{ width: '50%', cursor: 'pointer' }}
                onClick={() => handleOpen('right')}
              />
              {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
              </Stack> */}
            </Stack>

            <Stack direction="column" spacing={10}>
              <img
                src={img3}
                style={{ width: '50%', cursor: 'pointer' }}
                onClick={() => handleDownloadexcel(csvData)}
              />
              {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
              </Stack> */}
            </Stack>

            <Stack direction="column" spacing={10}>
              <img
                src={img4}
                style={{ width: '50%', cursor: 'pointer', borderRadius: '8px' }}
                onClick={() => handleOpenp('lg')}
              />
              {/* <Stack spacing={10} style={{ fontSize: '24px' }}>
                <Icon as={VisibleIcon} style={{ cursor: 'pointer', color: 'red' }} />
                <Icon as={EditIcon} style={{ cursor: 'pointer' }} />
              </Stack> */}
            </Stack>

            {/* <Button appearance='ghost' color='cyan' style={{ padding: 0 }} onClick={() => handleDownloadexcel(csvData)} >Download Excel</Button>
            <Button appearance='default' active onClick={() => handleOpenp('lg')}>Download PDF</Button> */}
          </ButtonGroup>
          <img src={img} style={{ width: 250, opacity: 0.3 }} />
          {/* <Form.ControlLabel><b className='generate-cate-text'>Copy the link below and share it with the buyer to view web collection </b></Form.ControlLabel> */}
          {/* <Form.ControlLabel>We will update you whenever the buyer opens the catalogue link, shortlists, products or share any queries</Form.ControlLabel> */}
          {/* <Panel bordered>
            <Stack spacing={90}>
              <Input value={textToCopy} readOnly style={{ width: "140%" }} />
              {showCopyButton && (
                <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
                  <Button appearance="primary" color="cyan">
                    Copy Link
                  </Button>
                </CopyToClipboard>
              )}
              {!showCopyButton && (
                <Button appearance="primary" color="cyan" onClick={handlelinkOpen}>
                  Generate Link
                </Button>
              )}
            </Stack>
          </Panel> */}
          {/* <CustomButtonGroup /> */}
        </Stack>
      </Container>
      <Modal open={link} onClose={handlelinkClose} backdrop="static" size="md">
        <Modal.Header>
          <Modal.Title>
            <b>Fill the Details</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-around">
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <b>Username</b>
              <Input
                id="username"
                name="username"
                value={glogin && glogin.username ? glogin.username : ''}
                onChange={value => handleInputChange('username', value, 0)}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <b>Password</b>
              <Input
                id="password"
                type="password"
                name="password"
                value={glogin && glogin.password ? glogin.password : ''}
                onChange={value => handleInputChange('password', value, 0)}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <b>Date Range</b>
              <DateRangePicker
                id="dateRange"
                value={dateRange}
                format="dd/MM/yyyy"
                onChange={handleDateRangeChange}
              />
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handlelinkClose} appearance="subtle" active>
            Cancel
          </Button>
          <Button onClick={handleOkClick} appearance="primary" color="cyan">
            Generate
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ////////Excel modal////////// */}
      {showModalexcel && (
        <Drawer size="xs" open={openexcel} onClose={handleCloseexcel} backdrop="static">
          <Drawer.Header>
            <Drawer.Title>
              <b>No. of Products</b>
            </Drawer.Title>
            <Drawer.Actions>
              <Stack justifyContent="flex-end">
                <InputGroup style={{ width: 100 }}>
                  <InputNumber value={valuee} onChange={handleCountChangee} min={1} max={3} />
                </InputGroup>
              </Stack>
            </Drawer.Actions>
          </Drawer.Header>
          <Drawer.Body>
            <Panel>
              {valuee === 1 ? (
                <FlexboxGrid justify="space-around">
                  <FlexboxGrid.Item
                    as={Col}
                    colspan={24}
                    md={12}
                    style={{ marginBottom: '10px' }}
                    className="pdf-lyt"
                  >
                    <Button
                      block
                      onClick={() => downloadExcelData(selectedRowDataexcel)}
                      className="pdf-layout"
                    >
                      <img src={s2} style={{ width: '88%' }} />
                    </Button>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item
                    as={Col}
                    colspan={24}
                    md={12}
                    style={{ marginBottom: '10px' }}
                    className="pdf-lyt"
                  >
                    <Button
                      block
                      onClick={() => downloadExcelData2(selectedRowDataexcel)}
                      className="pdf-layout"
                    >
                      <img src={s1} style={{ width: '88%' }} />
                    </Button>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              ) : null}
              {valuee === 2 ? (
                <div>
                  <Stack direction="column" spacing={30}>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>In Progress</b>
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>In Progress</b>
                      </Stack>
                    </Stack>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>In Progress</b>
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>In Progress</b>
                      </Stack>
                    </Stack>
                  </Stack>
                </div>
              ) : null}
              {valuee === 3 ? (
                <div>
                  <Stack direction="column" spacing={30}>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>In Progress</b>
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>In Progress</b>
                      </Stack>
                    </Stack>
                    <Stack spacing={5} justifyContent="space-between">
                      <Stack direction="column" alignItems="flex-start">
                        <Button appearance="default" style={{ border: '1px dotted gray' }}>
                          <Panel style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>In Progress</b>
                      </Stack>
                    </Stack>
                  </Stack>
                </div>
              ) : null}
            </Panel>
          </Drawer.Body>
        </Drawer>
      )}
      <Drawer size="xs" open={open} onClose={() => setOpen(false)}>
        <Drawer.Header>
          <Drawer.Title>
            <b>No. of Products on each slide:</b>
          </Drawer.Title>
          <Drawer.Actions>
            <Stack justifyContent="flex-end">
              <InputGroup style={{ width: 100 }}>
                <InputNumber value={value} onChange={handleCountChange} min={1} max={4} />
              </InputGroup>
            </Stack>
          </Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            {value === 1 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button1');
                    }}
                    className="pdf-layout"
                  >
                    <img src={s2} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    // onClick={handleDownloadPPT2}
                    className="pdf-layout"
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button2');
                    }}
                  >
                    <img src={s1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT4} className="pdf-layout">
                    <img src={s4} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button3');
                    }}
                    className="pdf-layout"
                  >
                    <img src={s5} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT5} className="pdf-layout">
                    <img src={s4} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button
                    block
                    onClick={() => {
                      setOpenAttri(true);
                      setSelectedButton('button4');
                    }}
                    className="pdf-layout"
                  >
                    <img src={s3} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
                {/* <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Button block onClick={handleDownloadPPT10} className='pdf-layout'>
                    <img src={s3} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item> */}
              </FlexboxGrid>
            ) : null}
            {value === 2 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT8} className="pdf-layout">
                    <img src={m5} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
            {value === 3 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT7} className="pdf-layout">
                    <img src={t1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
            {value === 4 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPPT9} className="pdf-layout">
                    <img src={f1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
          </Panel>
        </Drawer.Body>
      </Drawer>

      <Drawer size="xs" open={openp} onClose={handleClosep} backdrop="static">
        <Drawer.Header>
          <Drawer.Title>
            <b>No. of Products on each page:</b>
          </Drawer.Title>
          <Drawer.Actions>
            <Stack justifyContent="flex-end">
              <InputGroup style={{ width: 100 }}>
                <InputNumber value={valuep} onChange={handleCountChangep} min={1} max={3} />
              </InputGroup>
            </Stack>
          </Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            {valuep === 1 ? (
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPDF} className="pdf-layout">
                    <img src={s1} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item
                  as={Col}
                  colspan={24}
                  md={12}
                  style={{ marginBottom: '10px' }}
                  className="pdf-lyt"
                >
                  <Button block onClick={handleDownloadPDF2} className="pdf-layout">
                    <img src={s2} style={{ width: '88%' }} />
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            ) : null}
            {valuep === 2 ? (
              <div>
                <Stack direction="column" spacing={30}>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>In Progress</b>
                    </Stack>
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>In Progress</b>
                    </Stack>
                  </Stack>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>In Progress</b>
                    </Stack>
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>In Progress</b>
                    </Stack>
                  </Stack>
                </Stack>
              </div>
            ) : null}
            {valuep === 3 ? (
              <div>
                <Stack direction="column" spacing={30}>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>In Progress</b>
                    </Stack>
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>In Progress</b>
                    </Stack>
                  </Stack>
                  <Stack spacing={5} justifyContent="space-between">
                    <Stack direction="column" alignItems="flex-start">
                      <Button appearance="default" style={{ border: '1px dotted gray' }}>
                        <Panel style={{ width: 150 }}>
                          <Placeholder.Paragraph />
                        </Panel>
                      </Button>
                      <b>In Progress</b>
                    </Stack>
                  </Stack>
                </Stack>
              </div>
            ) : null}
          </Panel>
        </Drawer.Body>
      </Drawer>

      <Modal open={openattri} onClose={() => setOpenAttri(false)} backdrop="static">
        <Modal.Header>
          <Modal.Title>Custom Attributes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productName} onClick={() => setProductName(!productName)}>
                {label[0]?.attributes.ProductName}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productAlias} onClick={() => setProductAlias(!productAlias)}>
                {label[0]?.attributes.AliasCode}
              </Checkbox>
            </FlexboxGrid.Item>
            {sizeshow ? (
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox
                  checked={productsizerange}
                  onClick={() => setProductsizerange(!productsizerange)}
                >
                  {label[0]?.attributes.SizeRange}
                </Checkbox>
              </FlexboxGrid.Item>
            ) : (
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productsize} onClick={() => setProductSize(!productsize)}>
                  {label[0]?.attributes.Sizeunit}
                </Checkbox>
              </FlexboxGrid.Item>
            )}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productfinish} onClick={() => setProductFinish(!productfinish)}>
                {label[0]?.attributes.finish}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productntw} onClick={() => setProductNtw(!productntw)}>
                {label[0]?.attributes.NetWgt}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productcbm} onClick={() => setProductCbm(!productcbm)}>
                {label[0]?.attributes.cbm}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={productcategory}
                onClick={() => setProductCategory(!productcategory)}
              >
                {label[0]?.attributes.Category}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={producttype} onClick={() => setProductType(!producttype)}>
                {label[0]?.attributes.ProductType}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productdesc} onClick={() => setProductDesc(!productdesc)}>
                {label[0]?.attributes.Description}
              </Checkbox>
            </FlexboxGrid.Item>
            {/* <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productcolor} onClick={() => setProductColor(!productcolor)}>
                {label[0]?.attributes.color}
              </Checkbox>
            </FlexboxGrid.Item> */}
            {/* <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productgrt} onClick={() => setProductGrt(!productgrt)}>
                {label[0]?.attributes.GrossWgt}
              </Checkbox>
            </FlexboxGrid.Item> */}
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productsalepri} onClick={() => setProductSalepri(!productsalepri)}>
                {label[0]?.attributes.SalePrice}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox
                checked={productcurrency}
                onClick={() => setProductCurrency(!productcurrency)}
              >
                {label[0]?.attributes.Currency}
              </Checkbox>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
              <Checkbox checked={productremark} onClick={() => setProductRemark(!productremark)}>
                {label[0]?.attributes.ProductRemark}
              </Checkbox>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseandsave} appearance="primary" color="cyan">
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GenerateColl;
